import { Dispatch } from "redux";
import { setAuth, setUser, setUserPermissions, setUserTenant } from "./authSlice";
import axios from "../../axios/vendors/auth.axios"

import { Tenant } from "../../interfaces/vendors/auth.interface";
import { User } from "../../interfaces/users/user-list-response.interface";


export const checkAuth = () => (dispatch: Dispatch) => {

    // axios.defaults.headers.common['Authorization'] = `Bearer ${window.sessionStorage.getItem("token")}`;
    axios.get<User>(`/auth/me`).then(resp => {
        if(resp.data){
            dispatch(setUser(resp.data));
            dispatch(setAuth(2));
            return ;
        }
        dispatch(setAuth(1))
    }).catch(err => {
        dispatch(setAuth(1))
    })

        

};

